import LocalNetworkService from '@/services/LocalNetworkService';
import Terminal from '@/models/Terminal';

const TERMINAL_KEY = 'terminal';

const TerminalService = {

    /**
     * Set Terminal
     */
    setTerminal(terminal){
        this.setId(terminal.id);
        Terminal.insert({ data: [terminal] })
        LocalNetworkService.reload()
    },

    /**
     * Remove Terminal
     */
    removeTerminal(){
        this.removeId();
        LocalNetworkService.reload()
    },

    /**
     * Get Terminal Id
     */
    async getId() {
        return AppStorage.native().getItem(TERMINAL_KEY);
    },

    /**
     * Set Terminal Id
     */
    setId(id) {
        AppStorage.native().setItem(TERMINAL_KEY, id);
    },

    /**
     * Remove Terminal Id
     */
    removeId() {
        AppStorage.native().deleteItem(TERMINAL_KEY);
    },
};

export default TerminalService;

export { TerminalService };
